export function PageTrackingHandler() {
  return null
}
